import {
  Badge,
  Button,
  Checkbox,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Select,
  message,
} from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import qs from 'qs'
import React, { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { Tuning2OutlineIcon } from '../../../components/AppIcon'
import EmptyContent from '../../../components/EmptyContent'
import { DATE_FORMAT_LIST, ISO_DATE_FORMAT } from '../../../constants'
import utils from '../../../utils'
import { checkValidFormFieldValue } from '../../../utils/helper'

const { RangePicker } = DatePicker
const { Option } = Select

const InternalDocumentOutgoingDocAdvanceFilterV2 = props => {
  const [showFilter, setShowFilter] = useState(false)
  const [loadingBook, setLoadingBook] = useState(false)

  const {
    bookStore,
    authorityStore,
    handleChangeParams,
    queryParamsOutgoing,
  } = props

  const { bookGroupList, bookListOfGroup } = bookStore
  const { authorityIssuedsList } = authorityStore

  const location = useLocation()
  const queryStringParse = useMemo(
    () => qs.parse(location.search.replace('?', '')),
    [location.search]
  )
  const [form] = Form.useForm()
  const values = Form.useWatch([], form)
  const { setFieldsValue } = form

  const appliedFilterCount = useMemo(() => {
    let count = 0
    const hasValue = val => val && String(val).trim() !== ''

    if (hasValue(queryStringParse.title)) count++
    if (hasValue(queryStringParse.document_number)) count++
    if (hasValue(queryStringParse.book_group_id)) count++
    if (hasValue(queryStringParse.book_id)) count++
    if (queryStringParse.from_date_issued || queryStringParse.to_date_issued)
      count++
    if (hasValue(queryStringParse.document_type)) count++
    if (hasValue(queryStringParse.urgency_level)) count++
    if (hasValue(queryStringParse.authority_name)) count++
    if (hasValue(queryStringParse.signer)) count++
    if (
      queryParamsOutgoing?.only_unread === 'true' ||
      queryParamsOutgoing?.only_unread === true
    )
      count++

    return count
  }, [queryStringParse, queryParamsOutgoing])

  useEffect(() => {
    if (!queryStringParse.book_group_id) return
    ;(async () => {
      try {
        await bookStore.getBookByBookGroupId(queryStringParse.book_group_id)
      } catch (error) {
        console.log(error)
        message.error(error?.vi || 'Đã có lỗi xảy ra!')
      }
    })()
  }, [])

  useEffect(() => {
    if (showFilter) {
      setFieldsValue({
        title: queryStringParse.title || undefined,
        document_number: queryStringParse.document_number || undefined,
        book_group_id: queryStringParse.book_group_id
          ? parseInt(queryStringParse.book_group_id)
          : undefined,
        book_id: queryParamsOutgoing.book_id
          ? parseInt(queryParamsOutgoing.book_id)
          : undefined,
        date_issued:
          queryStringParse.from_date_issued && queryStringParse.to_date_issued
            ? [
                moment(queryStringParse.from_date_issued),
                moment(queryStringParse.to_date_issued),
              ]
            : undefined,
        document_type: queryStringParse.document_type || undefined,
        urgency_level: queryStringParse.urgency_level || undefined,
        signer: queryStringParse.signer || undefined,
        authority_name:
          queryStringParse.authority_name &&
          String(queryStringParse.authority_name).trim() !== ''
            ? [queryStringParse.authority_name]
            : [],
        only_unread:
          queryParamsOutgoing?.only_unread === 'true' ||
          queryParamsOutgoing?.only_unread === true,
      })
    }
  }, [queryStringParse, queryParamsOutgoing, setFieldsValue, showFilter])

  const onFinish = values => {
    const params = {
      title: values.title ? values.title.trim() : null,
      document_number: values.document_number
        ? values.document_number.trim()
        : null,
      book_group_id: values.book_group_id || null,
      book_id: values.book_id || null,
      from_date_issued: values.date_issued
        ? moment(values.date_issued[0]).format(ISO_DATE_FORMAT)
        : null,
      to_date_issued: values.date_issued
        ? moment(values.date_issued[1]).format(ISO_DATE_FORMAT)
        : null,
      document_type: values.document_type || null,
      urgency_level: values.urgency_level || null,
      signer: values.signer ? values.signer.trim() : null,
      authority_name: values.authority_name ? values.authority_name : null,
      only_unread: values.only_unread ? true : false,
    }
    handleChangeParams(params)
    onToggleFilter()
  }

  const onChangeBookGroupId = async book_group_id => {
    form.setFieldsValue({ book_id: undefined })
    if (!book_group_id) {
      bookStore.clearBookListOfGroup()
      return
    }
    setLoadingBook(true)
    form.setFieldsValue({ book_id: null, book_group_id: book_group_id })
    try {
      await bookStore.getBookByBookGroupId(book_group_id)
    } finally {
      setLoadingBook(false)
    }
  }

  const filterSelectOption = (input, option) => {
    return (
      utils
        .nonAccentVietnamese(option.name)
        .indexOf(utils.nonAccentVietnamese(input)) >= 0
    )
  }

  const onToggleFilter = () => {
    setShowFilter(prev => !prev)
  }

  const hasFormValue = Object.values(values || {}).some(
    checkValidFormFieldValue
  )

  return (
    <Dropdown
      open={showFilter}
      onOpenChange={onToggleFilter}
      trigger={['click']}
      dropdownRender={() => (
        <div className="custom-page-filter-dropdown-container ">
          <Form form={form} onFinish={onFinish} layout="vertical">
            <div className="form-elements">
              <Form.Item
                label="Trích yếu / Số hiệu"
                name="title"
                style={{ marginBottom: 16 }}>
                <Input
                  placeholder="Trích yếu / Số hiệu"
                  allowClear
                  className="h-40"
                />
              </Form.Item>
              <Form.Item
                label="Số hiệu"
                name="document_number"
                style={{ marginBottom: 16 }}>
                <Input
                  placeholder={'Nhập số hiệu'}
                  allowClear
                  className="h-40"
                />
              </Form.Item>
              <Form.Item
                label="Nhóm sổ văn bản"
                name="book_group_id"
                style={{ marginBottom: 16 }}>
                <Select
                  style={{ width: '100%' }}
                  allowClear
                  onChange={onChangeBookGroupId}
                  showSearch
                  notFoundContent={<EmptyContent />}
                  optionFilterProp={'name'}
                  placeholder={'Chọn nhóm sổ văn bản'}
                  className="h-40">
                  {bookGroupList.map(book => (
                    <Option key={book.id} value={book.id} name={book.name}>
                      {book.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label="Sổ văn bản"
                name="book_id"
                style={{ marginBottom: 16 }}>
                <Select
                  style={{ width: '100%' }}
                  loading={loadingBook}
                  allowClear
                  showSearch
                  notFoundContent={<EmptyContent />}
                  filterOption={true}
                  optionFilterProp={'name'}
                  disabled={!values?.book_group_id}
                  placeholder={'Chọn sổ văn bản'}
                  className="h-40">
                  {bookListOfGroup.map(book => (
                    <Option key={book.id} value={book.id} name={book.name}>
                      {book.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label="Ngày ban hành"
                name="date_issued"
                style={{ marginBottom: 16 }}>
                <RangePicker
                  placeholder={['Ngày ban hành: Từ ngày', 'Đến ngày']}
                  format={DATE_FORMAT_LIST}
                  style={{ width: '100%' }}
                  className="h-40"
                />
              </Form.Item>
              <Form.Item
                label="Loại văn bản"
                name="document_type"
                style={{ marginBottom: 16 }}>
                <Select
                  style={{ width: '100%' }}
                  allowClear
                  notFoundContent={<EmptyContent />}
                  placeholder={'Chọn loại văn bản'}
                  className="h-40">
                  <Option value={'020'}>Báo cáo</Option>
                  <Option value={'021'}>Công văn</Option>
                  <Option value={'022'}>Quyết định</Option>
                  <Option value={'023'}>Thông báo - Giấy mời</Option>
                  <Option value={'024'}>Tờ trình</Option>
                </Select>
              </Form.Item>
              <Form.Item
                label="Độ khẩn"
                name="urgency_level"
                style={{ marginBottom: 16 }}>
                <Select
                  style={{ width: '100%' }}
                  allowClear
                  notFoundContent={<EmptyContent />}
                  placeholder={'Chọn độ khẩn'}
                  className="h-40">
                  <Option value={'001'}>Thường</Option>
                  <Option value={'002'}>Quan trọng</Option>
                  <Option value={'003'}>Rất quan trọng</Option>
                </Select>
              </Form.Item>
              <Form.Item
                label="Bộ phận dự thảo"
                name="authority_name"
                style={{ marginBottom: 16 }}>
                <Select
                  style={{ width: '100%' }}
                  filterOption={filterSelectOption}
                  allowClear
                  showSearch
                  showArrow
                  optionFilterProp={'name'}
                  notFoundContent={<EmptyContent />}
                  placeholder={'Chọn hoặc nhập bộ phận dự thảo'}
                  className="h-40">
                  {authorityIssuedsList.map(authorityIssued => (
                    <Option
                      name={authorityIssued.name}
                      value={authorityIssued.name}
                      key={authorityIssued.id}>
                      {authorityIssued.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label="Người ký"
                name="signer"
                style={{ marginBottom: 16 }}>
                <Input placeholder={'Người ký'} allowClear className="h-40" />
              </Form.Item>
              <Form.Item
                label="Trạng thái văn bản"
                name="only_unread"
                valuePropName="checked"
                style={{ marginBottom: 16 }}>
                <Checkbox>Hiển thị văn bản chưa đọc</Checkbox>
              </Form.Item>
            </div>
            <div
              style={{
                marginTop: '5px',
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                justifyContent: hasFormValue ? 'space-between' : 'center',
                padding: '0 20px',
              }}>
              <Button
                className="custom-ant-button"
                type="primary"
                htmlType="submit">
                Áp dụng
              </Button>
              <Button
                className="custom-ant-button"
                htmlType="button"
                onClick={onToggleFilter}>
                Đóng
              </Button>

              <Button
                className="custom-ant-button"
                style={{
                  display: hasFormValue ? 'flex' : 'none',
                  marginLeft: 'auto',
                }}
                htmlType="reset"
                onClick={() => {
                  form.resetFields()
                  onToggleFilter()
                  handleChangeParams({}, true)
                }}>
                Xóa
              </Button>
            </div>
          </Form>
        </div>
      )}
      placement="bottomRight">
      <Badge count={appliedFilterCount} offset={[-6, -3]}>
        <Button
          className="custom-page-filter-dropdown-btn"
          icon={
            <Tuning2OutlineIcon
              style={{
                width: 16,
                height: 16,
              }}
            />
          }
        />
      </Badge>
    </Dropdown>
  )
}

InternalDocumentOutgoingDocAdvanceFilterV2.propTypes = {}

export default inject(
  'bookStore',
  'loadingAnimationStore',
  'authorityStore',
  'internalDocumentStore'
)(observer(InternalDocumentOutgoingDocAdvanceFilterV2))
